import { Box, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiFilter2Line } from 'react-icons/ri';

import { MyDispositionsProvider, useMyDispositionsContext } from './context';
import List from './components/List';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const Page = () => {
  const { showFilters, setShowFilters } = useMyDispositionsContext();

  return (
    <Box>
      <Flex alignItems="center" mb={2}>
        <Heading>
          Meus atendimentos
        </Heading>
        <IconButton
          variant="ghost"
          color="argos.fg"
          onClick={() => setShowFilters((prev) => !prev)}
        >
          <RiFilter2Line size={24} />
        </IconButton>
      </Flex>

      {showFilters ? (
        <Filters />
      ) : (
        <SelectedFiltersList />
      )}
      
      <List />
    </Box>
  );
};

const MyDispositions = () => (
  <MyDispositionsProvider>
    <Page />
  </MyDispositionsProvider>
);

export default MyDispositions;
